import { useState } from 'react';
import { GiftIcon } from 'lucide-react';
import { useCartActions } from '../../contexts/StoreContext';
import { useCatalog } from '../../contexts/CatalogContext';
import { policyCopy } from '../../data/policies';
import { founder } from '../../data/content';
import { euro } from '../../core/format/currency';
import { btnPrimary, choiceState } from '../../ui/styles';
import { sectionHeading } from '../../ui/sections';
import { Section } from './Section';

/** Cadeaubon: bedrag kiezen en toevoegen. Het middelste bedrag staat voorgeselecteerd. */
export function GiftCardBlock() {
  const {
    add
  } = useCartActions();
  const {
    giftCards
  } = useCatalog();
  const fallback = giftCards[1] ?? giftCards[0];
  const [selected, setSelected] = useState(fallback?.id ?? '');
  const card = giftCards.find(g => g.id === selected) ?? fallback;
  if (!card) return null;
  return <Section tone="blush" labelledBy="cadeaubon" contained={false} data-id="element-8905" data-mp="3pt7insqbh58u">
      <div className="mx-auto grid max-w-content items-center gap-12 px-6 lg:grid-cols-12 lg:gap-16 lg:px-10" data-id="element-8906" data-mp="3puimttnocf0h">
        <div className="lg:col-span-7" data-id="element-8907" data-mp="37zcoztqzpdi7">
          <p className="flex items-center gap-2 text-[14px] text-ink" data-id="element-8908" data-mp="32yow12j7amlc">
            <GiftIcon className="h-4 w-4 text-clay" strokeWidth={1.5} aria-hidden="true" data-id="element-8909" data-mp="330i3gk1n1aue" />
            Cadeaubon
          </p>
          <h2 id="cadeaubon" className={`mt-5 max-w-2xl ${sectionHeading} text-ink`} data-id="element-8910" data-mp="3cvtmhek2x47y">
            Geef geen product cadeau, geef de keuze
          </h2>
          <p className="mt-6 max-w-xl text-[17px] leading-relaxed text-muted" data-id="element-8911" data-mp="3qu1f5aa31jdb">
            De ontvanger besteedt de bon aan producten of een behandeling in de salon, met persoonlijk advies van {founder.firstName} erbij. Direct per mail,{' '}
            {policyCopy.giftCardValidity.toLowerCase()}.
          </p>
        </div>

        <div className="lg:col-span-5" data-id="element-8912" data-mp="dh7uwr6djh8b">
          <div className="bg-shell p-7 lg:p-8" data-id="element-8913" data-mp="dhzojwgev4vy">
            <fieldset data-id="element-8914" data-mp="8i4xnswmyfaw">
              <legend className="type-name text-ink" data-id="element-8915" data-mp="8in1pbpjhxtd">Kies een bedrag</legend>
              <div className="mt-4 grid grid-cols-3 gap-2" data-id="element-8916" data-mp="32a39cd9t5pwx">
                {giftCards.map(g => {
                const active = g.id === card.id;
                return <button key={g.id} type="button" aria-pressed={active} onClick={() => setSelected(g.id)} className={`py-4 text-center type-name ${choiceState(active)}`} data-id="element-8917" data-mp="3773gysmb30q5">
                      {euro(g.price)}
                    </button>;
              })}
              </div>
            </fieldset>
            <button type="button" onClick={() => add(card)} className={`${btnPrimary} mt-5 w-full py-3.5`} data-id="element-8918" data-mp="3uyim0t5gvw53">
              Cadeaubon van {euro(card.price)} toevoegen
            </button>
            <p className="mt-3 text-center text-[13px] text-muted" data-id="element-8919" data-mp="20l97gmy2dkfz">Persoonlijke boodschap toevoegen kan bij het afrekenen.</p>
          </div>
        </div>
      </div>
    </Section>;
}